/**
 * tdesign v1.8.0
 * (c) 2024 tdesign
 * @license MIT
 */

import { elementInViewport, getWindowSize, scrollTo } from '../../utils/dom.mjs';
import '../../_chunks/dep-6f3e4f56.mjs';
import '../../_chunks/dep-5f6c8826.mjs';
import '../../_chunks/dep-b1060562.mjs';
import '../../_chunks/dep-b333ab93.mjs';
import '../../_chunks/dep-0d1bd08c.mjs';
import '../../_chunks/dep-c5d88cfe.mjs';
import '../../_chunks/dep-8049d2e0.mjs';
import '../../_chunks/dep-97c71289.mjs';
import '../../_chunks/dep-4efc69ee.mjs';
import '../../utils/easing.mjs';

function scrollToElm(elm) {
  var rect = elm.getBoundingClientRect();
  if (!elementInViewport(elm)) {
    var winHeight = getWindowSize().height;
    scrollTo(rect.top - (winHeight / 2 - rect.height / 2), {});
  }
}

export { scrollToElm as default };
//# sourceMappingURL=scrollToElm.mjs.map
